import { api } from './api';

/**
 * RC-8 W9 — temporary clerk delegation (coverage) web client. Mirrors the server
 * ClerkDelegation model. A covering clerk sees the delegating clerk's barristers for a date
 * window; expiry is derived from the window (no job).
 */

export interface ClerkDelegation {
  id: string;
  fromClerkUserId: string;
  fromClerkName: string;
  toClerkUserId: string;
  toClerkName: string;
  startDate: string; // YYYY-MM-DD
  endDate: string;
  reason: string | null;
  revokedAt: string | null;
  /** Derived server-side: within the window today and not revoked. */
  active: boolean;
}

export interface CreateDelegationPayload {
  fromClerkUserId: string;
  toClerkUserId: string;
  startDate: string;
  endDate: string;
  reason?: string;
}

export async function fetchDelegations(): Promise<ClerkDelegation[]> {
  const res = await api.get<{ data: ClerkDelegation[] }>('/clerk-delegations');
  return res.data.data ?? [];
}

export async function createDelegation(payload: CreateDelegationPayload): Promise<ClerkDelegation> {
  const res = await api.post<{ data: ClerkDelegation }>('/clerk-delegations', payload);
  return res.data.data;
}

export async function revokeDelegation(id: string): Promise<void> {
  await api.post(`/clerk-delegations/${id}/revoke`);
}
